import { Observable, timer } from 'rxjs';

export function getConfiguredDelayByPage(pageName: string, delayConfig: Record<string, string>): Observable<number> {
    if (delayConfig[pageName]) {
        return timer(+delayConfig[pageName]);
    }
    return timer(0);
}
